/**
 * Validação de e-mail do cliente. Bloqueia o que costuma travar o pagamento/cobrança
 * (pontos duplicados, ponto no início/fim, domínio sem extensão) e erros de digitação comuns de provedores.
 */

const COMMON_DOMAIN_TYPOS: Record<string, string> = {
  'gmial.com': 'gmail.com',
  'gmai.com': 'gmail.com',
  'gmal.com': 'gmail.com',
  'gamil.com': 'gmail.com',
  'gmail.con': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmail.com.br': 'gmail.com',
  'gmail.cm': 'gmail.com',
  'hotmial.com': 'hotmail.com',
  'hotmai.com': 'hotmail.com',
  'hotmail.con': 'hotmail.com',
  'hotmail.co': 'hotmail.com',
  'outlok.com': 'outlook.com',
  'outlook.con': 'outlook.com',
  'yaho.com': 'yahoo.com',
  'yahoo.con': 'yahoo.com',
  'yahoo.co': 'yahoo.com',
  'icloud.con': 'icloud.com',
  'uol.com': 'uol.com.br',
  'bol.com': 'bol.com.br',
};

const LOCAL_PART = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
const DOMAIN_LABEL = /^[A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?$/;

/** Mensagem do problema encontrado no e-mail, ou null se está tudo certo. */
export const getEmailProblem = (value: string): string | null => {
  const email = (value ?? '').trim();
  if (!email) return 'Informe seu e-mail.';
  if (/\s/.test(email)) return 'O e-mail não pode ter espaços.';

  const at = email.indexOf('@');
  if (at <= 0 || at !== email.lastIndexOf('@')) return 'Confira o e-mail: ele precisa ter um único @ (ex.: nome@gmail.com).';

  const local = email.slice(0, at);
  const domain = email.slice(at + 1).toLowerCase();

  if (email.includes('..')) return 'Confira o e-mail: há dois pontos seguidos.';
  if (!LOCAL_PART.test(local)) return 'Confira o e-mail: o nome antes do @ tem ponto no começo/fim ou caracteres inválidos.';

  const labels = domain.split('.');
  if (labels.length < 2 || labels.some((l) => !l || !DOMAIN_LABEL.test(l))) {
    return 'Confira o e-mail: o final está incompleto (ex.: nome@gmail.com).';
  }
  if (!/^[a-z]{2,}$/.test(labels[labels.length - 1])) return 'Confira o e-mail: a terminação (.com, .com.br…) está incorreta.';

  const suggestion = COMMON_DOMAIN_TYPOS[domain];
  if (suggestion) return `Confira o e-mail: você quis dizer ${local}@${suggestion}?`;

  return null;
};

export const isValidEmailStrict = (value: string): boolean => getEmailProblem(value) === null;
